import {
  MdOutlineDashboard,
  MdHistory,
  MdPeopleOutline,
  MdOutlinePeople,
} from "react-icons/md";

import { LuClipboardPaste, LuClipboardSignature } from "react-icons/lu";
import { MdOutlineMonitor } from "react-icons/md";
import { FiMonitor, FiUsers } from "react-icons/fi";
import { RiStackFill } from "react-icons/ri";
import {
  HiOutlineDocumentDuplicate,
  HiOutlineDocumentSearch,
} from "react-icons/hi";
import { MdOutlineManageAccounts } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import { BsPeople } from "react-icons/bs";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { TbUserEdit } from "react-icons/tb";

export const adminMenuItems = [
  {
    title: "Dashboard",
    path: "/admin/super-admin",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "Konfirmasi Pengajuan",
    path: "/admin/super-admin/pengelolaan-pengajuan",
    icon: <IoDocumentAttachOutline />,
  },
  {
    title: "Proses Program",
    path: "/admin/super-admin/proses-program",
    icon: <LuClipboardPaste />,
  },
  {
    title: "Pengelolaan Tim",
    path: "/admin/super-admin/pengelolaan-tim",
    icon: <MdOutlinePeople />,
    subMenu: [
      {
        title: "Kelola Tim",
        path: "/admin/super-admin/pengelolaan-tim/kelola-tim",
        icon: <MdManageAccounts />,
      },
      {
        title: "Susun Tim",
        path: "/admin/super-admin/pengelolaan-tim/susun-tim",
        icon: <RiStackFill />,
      },
    ],
  },
  {
    title: "Pengelolaan Dokumen",
    path: "/admin/super-admin/pengelolaan-dokumen",
    icon: <HiOutlineDocumentDuplicate />,
  },
  {
    title: "Penilaian Program",
    path: "/admin/super-admin/penilaian-dokumen",
    icon: <LuClipboardSignature />,
  },
  {
    title: "Penilaian Akhir",
    path: "/admin/super-admin/penilaian-akhir",
    icon: <HiOutlineDocumentSearch />,
  },
  {
    title: "Monitoring & Evaluasi",
    path: "/admin/super-admin/monitoring-evaluasi",
    icon: <MdOutlineMonitor />,
  },
  {
    title: "Atur Sekretariat",
    path: "/admin/super-admin/atur-sekretariat",
    icon: <TbUserEdit />,
  },
  {
    title: "Riwayat Pengajuan",
    path: "/admin/super-admin/riwayat-pengajuan",
    icon: <MdHistory />,
  },
];

export const mitraMenuItems = [
  {
    title: "Dashboard",
    path: "/mitra",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "Pengelolaan Akreditasi",
    path: "/mitra/pengelolaan-akreditasi",
    icon: <LuClipboardSignature />,
  },

  {
    title: "Riwayat Pengajuan",
    path: "/mitra/riwayat-pengajuan",
    icon: <MdHistory />,
  },
];

export const sekreMenuItems = [
  {
    title: "Dashboard",
    path: "/admin/sekretariat",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "Konfirmasi Pengajuan",
    path: "/admin/sekretariat/pengelolaan-pengajuan",
    icon: <IoDocumentAttachOutline />,
  },
  {
    title: "Proses Program",
    path: "/admin/sekretariat/proses-program",
    icon: <LuClipboardPaste />,
  },

  {
    title: "Pengelolaan Tim",
    path: "/admin/sekretariat/pengelolaan-tim",
    icon: <MdOutlinePeople />,
    subMenu: [
      {
        title: "Susun Tim",
        path: "/admin/sekretariat/pengelolaan-tim/susun-tim",
        icon: <RiStackFill />,
      },
      {
        title: "Kelola Tim",
        path: "/admin/sekretariat/pengelolaan-tim/kelola-tim",
        icon: <MdManageAccounts />,
      },
    ],
  },
  {
    title: "Pengelolaan Dokumen",
    path: "/admin/sekretariat/pengelolaan-dokumen",
    icon: <HiOutlineDocumentDuplicate />,
  },
  {
    title: "Penilaian Program",
    path: "/admin/sekretariat/penilaian-dokumen",
    icon: <LuClipboardSignature />,
  },
  {
    title: "Penilaian Akhir",
    path: "/admin/sekretariat/penilaian-akhir",
    icon: <HiOutlineDocumentSearch />,
  },
  {
    title: "Monitoring & Evaluasi",
    path: "/admin/sekretariat/monitoring-evaluasi",
    icon: <MdOutlineMonitor />,
  },
  {
    title: "Riwayat Pengajuan",
    path: "/admin/sekretariat/riwayat-pengajuan",
    icon: <MdHistory />,
  },
];
export const asessorMenuItems = [
  {
    title: "Dashboard",
    path: "/admin/assessor",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "Pengelolaan Dokumen",
    path: "/admin/assessor/pengelolaan-dokumen",
    icon: <HiOutlineDocumentSearch />,
  },
  {
    title: "Penilaian Program",
    path: "/admin/assessor/penilaian",
    icon: <LuClipboardSignature />,
  },

  {
    title: "Riwayat Pengajuan",
    path: "/admin/assessor/riwayat-pengajuan",
    icon: <MdHistory />,
  },
];

export const evaluatorMenuItems = [
  {
    title: "Dashboard",
    path: "/admin/evaluator",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "Pengelolaan Dokumen",
    path: "/admin/evaluator/pengelolaan-dokumen",
    icon: <LuClipboardSignature />,
  },
  {
    title: "Penilaian Program",
    path: "/admin/evaluator/penilaian",
    icon: <HiOutlineDocumentSearch />,
  },
  {
    title: "Riwayat Pengajuan",
    path: "/admin/evaluator/riwayat-pengajuan",
    icon: <MdHistory />,
  },
];

export const penilaiAkhirMenuItems = [
  {
    title: "Dashboard",
    path: "/admin/penilai-akhir",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "Pengelolaan Dokumen",
    path: "/admin/penilai-akhir/pengelolaan-dokumen",
    icon: <LuClipboardSignature />,
  },

  {
    title: "Penilaian Dokumen",
    path: "/admin/penilai-akhir/penilaian-dokumen",
    icon: <HiOutlineDocumentSearch />,
  },
  {
    title: "Riwayat Pengajuan",
    path: "/admin/penilai-akhir/riwayat-pengajuan",
    icon: <MdHistory />,
  },
];

export const accordionDataSuperAdmin = [
  {
    title: "Registrasi Akun",
    description: `
      <ul>
        <li>Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan registrasi.</li>
        <li>Anda akan diarahkan ke halaman pilihan login.</li>
        <li>Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN.</li>
        <li>Anda akan diarahkan ke halaman login SELAIN KEMENTERIAN KEUANGAN.</li>
        <li>Pilih tombol DAFTAR KLC-ID untuk melakukan registrasi akun.</li>
        <li>Anda akan diarahkan ke halaman Daftar Akun.</li>
        <li>Masukan data-data yang dibutuhkan untuk melakukan registrasi akun, lalu tekan tombol DAFTAR.</li>
        <li>Anda berhasil membuat Akun yang dapat digunakan untuk masuk ke dalam Web Aplikasi KLC AKREDITASI.</li>
      </ul>
    `,
  },
  {
    title: "Login dengan Kemenkeu ID",
    description: `
      <ul>
        <li>Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan Login.</li>
        <li>Anda akan diarahkan ke halaman pilihan login.</li>
        <li>Pilih tombol masuk dengan KEMENTERIAN KEUANGAN.</li>
        <li>Anda akan diarahkan ke halaman login SSO Kemenkeu.</li>
        <li>Masukkan Username dan Password. Kemudian pilih tombol Login.</li>
        <li>Anda berhasil masuk ke Web Aplikasi KLC AKREDITASI sesuai peran masing-masing.</li>
      </ul>
    `,
  },
  {
    title: "Login dengan Username",
    description: `
      <ul>
        <li>Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN.</li>
        <li>Akan muncul halaman login.</li>
        <li>Masukkan Username dan Password. Kemudian pilih tombol MASUK.</li>
        <li>Anda berhasil masuk ke Web Aplikasi KLC AKREDITASI Admin sesuai peran masing-masing.</li>
      </ul>
    `,
  },
  {
    title: "Logout",
    description: `
      <ul>
        <li>Pilih menu profil pengguna pada bagian kanan atas halaman.</li>
        <li>Pilih tombol Keluar.</li>
        <li>Pilih tombol IYA, KELUAR pada konfirmasi untuk menutup sesi.</li>
        <li>Sistem akan langsung menutup sesi dan meneruskan ke halaman Landing Page.</li>
      </ul>
    `,
  },
  {
    title: "Masuk ke dalam Dashboard Admin",
    description: `
      <ul>
        <li>Pilih menu Profile pengguna pada bagian kanan atas halaman.</li>
        <li>Pilih tombol Halaman Utama.</li>
        <li>Anda akan ditampilkan halaman Dashboard Admin.</li>
      </ul>
    `,
  },
  {
    title: "Menerima Pengajuan Lembaga",
    description: `
      <ul>
        <li>Pilih menu Konfirmasi Pengajuan pada bagian sidebar kiri halaman.</li>
        <li>Pilih tombol TERIMA pada Tabel Konfirmasi Pengajuan.</li>
        <li>Masukan nama Lembaga dan Upload surat pemberitahuan penerimaan. Kemudian tekan tombol Simpan.</li>
        <li>Anda berhasil Menerima Pengajuan Lembaga.</li>
      </ul>
    `,
  },
  {
    title: "Menolak Pengajuan Lembaga",
    description: `
      <ul>
        <li>Pilih menu Konfirmasi Pengajuan pada bagian sidebar kiri halaman.</li>
        <li>Pilih tombol TOLAK pada tabel Konfirmasi Pengajuan.</li>
        <li>Upload surat pemberitahuan penolakan. Kemudian tekan tombol Simpan.</li>
        <li>Anda berhasil Menolak Pengajuan Lembaga.</li>
      </ul>
    `,
  },
  {
    title: "Upload File Konsultasi",
    description: `
      <ul>
        <li>Pilih menu Konfirmasi Pengajuan pada bagian sidebar kiri halaman.</li>
        <li>Pilih Tombol Unggah FIle Konsultasi pada tabel Konfirmasi Pengajuan.</li>
        <li>Upload surat Hasil Konsultasi. Kemudian tekan tombol Simpan.</li>
        <li>Akan muncul Pop up Konfirmasi. Kemudian tekan tombol Ya.</li>
        <li>Anda berhasil Mengupload surat hasil Konsultasi.</li>
      </ul>
    `,
  },
  {
    title: "Memproses (Menerima atau Menolak) Program",
    description: `
      <ul>
        <li>Pilih menu Proses Program pada bagian sidebar kiri halaman.</li>
        <li>Pilih Tombol Proses Program yang terdapat pada tabel Proses Program untuk masuk ke dalam halaman detail Pengajuan.</li>
        <li>Pilih tombol “TERIMA” untuk menerima program, dan “TOLAK” untuk menolak program.</li>
        <li>Upload file Surat Pemberitahuan Persetujuan Permohonan Akreditasi Program. Kemudian pilih tombol Kirim.</li>
        <li>Pilih tombol Simpan untuk mengkonfirmasi terima Program.</li>
        <li>Anda berhasil Menerima/Menolak Program.</li>
      </ul>
    `,
  },
  {
    title: "Menyusun Tim Assessor dan Penilaian Akhir",
    description: `
      <ul>
        <li>Pilih menu Susun Tim pada bagian sidebar kiri halaman.</li>
        <li>Pilih tombol Susun Tim pada tabel Susun Tim untuk masuk ke dalam halaman detail Susun Tim.</li>
        <li>Masukan data NIP/Nama pegawai yang ingin ditugaskan sebagai Assessor atau Penilai Akhir.</li>
        <li>Masukan Minimal 3 Karakter untuk program melakukan pencarian. Kemudian tekan data pegawai yang ingin dipilih.</li>
        <li>Jika Tim Assessor dan Penilai Akhir sudah dipilih, tekan tombol SIMPAN untuk menyimpan data.</li>
        <li>Akan muncul Pop up Konfirmasi dengan Menampilkan data-data Pegawai yang sudah dipilih.</li>
        <li>Anda berhasil Menyusun TIm Assessor dan Penilaian Akhir.</li>
      </ul>
    `,
  },
  {
    title: "Menyusun Sekretariat",
    description: `
      <ul>
        <li>Pilih menu Atur Sekretariat pada bagian sidebar kiri halaman.</li>
        <li>Untuk Menambahkan Sekretariat, tekan Tombol TAMBAH SEKRETARIAT pada bagian atas kanan halaman menu Atur Sekretariat.</li>
        <li>Masukan NIP/NAMA untuk mencari pegawai, masukan minimal 3 karakter untuk mencari.</li>
        <li>Tekan tombol Simpan untuk menambahkan data pegawai ke dalam Table.</li>
        <li>Untuk Menghapus sekretariat, tekan tombol HAPUS pada kolom Aksi pada tabel Atur Sekretariat.</li>
        <li>Tekan tombol Ya,Hapus untuk mengkonfirmasi hapus sekretariat.</li>
        <li>Anda berhasil Menambahkan dan Menghapus Sekretariat.</li>
      </ul>
    `,
  },
  {
    title: "Menghapus dan Menambahkan Tim Assessor atau Penilaian Akhir",
    description: `
      <ul>
        <li>Pilih menu Kelola Tim pada bagian sidebar kiri halaman.</li>
        <li>Pilih tombol SUSUN TIM yang terdapat pada tabel Kelola Tim untuk masuk ke halaman detail Kelola Tim.</li>
        <li>Tekan tombol +ANGGOTA untuk menambahkan tim Assessor ataupun tim Penilaian Akhir.</li>
        <li>Masukan NIP/NAMA untuk mencari pegawai, masukan minimal 3 karakter untuk mencari.</li>
        <li>Tekan tombol Simpan untuk menambahkan data pegawai ke dalam Table.</li>
        <li>Tekan tombol SIMPAN PERUBAHAN pada halaman detail Kelola tim untuk menyimpan perubahan yang dilakukan.</li>
        <li>Tekan tombol HAPUS untuk menghapus Pegawai dari Tim Assessor atau Tim Penilaian Akhir.</li>
        <li>Tekan Tombol Ya, Hapus jika sudah yakin.</li>
        <li>Anda berhasil Menghapus pegawai dari Tim Assessor atau Tim Penilaian Akhir.</li>
      </ul>
    `,
  },
  {
    title: "Menilai Status Dokumen Setiap Program",
    description: `
      <ul>
        <li>Pilih menu Pengelolaan Dokumen pada sidebar kiri halaman.</li>
        <li>pilih dan tekan Judul Program yang ingin anda lihat status dokumennya yang terdapat pada tabel Pengelolaan Dokumen.</li>
        <li>Untuk menerima ataupun menolak dokumen, Anda dapat mengunduh dokumen dengan menekan logo download dokumen pada kolom file.</li>
        <li>Untuk melihat riwayat revisi dokumen anda dapat Klik “Lihat” di bawah kolom “Riwayat” (Riwayat) pada tabel untuk melihat detail dan riwayat dokumen yang telah diajukan.</li>
        <li>Untuk memproses dokumen, pada kolom “Aksi” (Tindakan) Anda memiliki dua pilihan: Terima (Terima) atau Tolak (Tolak).</li>
        <li>Konfirmasikan tindakan dengan menekan tombol SIMPAN.</li>
        <li>Anda berhasil Menilai Status Dokumen Setiap Program.</li>
      </ul>
    `,
  },
];

export const accordionDataPenilaiAkhir = [
  {
    title: "Registrasi Akun",
    description: `
          Menu Registrasi Akun menjelaskan cara untuk membuat akun yang akan digunakan pada aplikasi ini.
          Langkah-langkah Registrasi pada web aplikasi AKREDITASI adalah sebagai berikut:
          - Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan registrasi
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Anda akan diarahkan ke halaman login SELAIN KEMENTERIAN KEUANGAN
          - Pilih tombol DAFTAR KLC-ID untuk melakukan registrasi akun
          - Anda akan diarahkan ke halaman Daftar Akun
          - Masukan data-data yang dibutuhkan untuk melakukan registrasi akun, lalu tekan tombol DAFTAR.
          - Anda berhasil membuat Akun yang dapat digunakan untuk masuk ke dalam Web Aplikasi Akreditasi.
      `,
  },
  {
    title: "Login dengan Username",
    description: `
          Menu Login dengan username menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun yang didaftar.
          Langkah-langkah login pada Aplikasi SKP dengan menggunakan KLC-ID adalah sebagai berikut:
          - Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan login
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Akan muncul halaman login.
          - Masukkan Username dan Password. Kemudian pilih tombol MASUK.
          - Anda berhasil masuk ke Web Aplikasi AKREDITASI.
      `,
  },
  {
    title: "Login dengan akun Google",
    description: `
          Menu Login dengan username menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun google.
          Langkah-langkah login pada Aplikasi SKP dengan menggunakan KLC-ID adalah sebagai berikut:
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Akan muncul halaman login. Lalu, tekan tombol Masuk dengan Google.
          - Pilih email yang diinginkan.
          - Anda berhasil masuk ke Web Aplikasi AKREDITASI.
      `,
  },
  {
    title: "Masuk ke dalam Dashboard Penilai Akhir",
    description: `
          Langkah-langkah yang dilakukan untuk Masuk ke dalam Dashboard penilai Akhir adalah sebagai berikut:
          - Pilih menu profil pengguna pada bagian kanan atas halaman.
          - Pilih tombol Halaman Utama.
          - Anda akan ditampilkan halaman Dashboard Penilai Akhir.
      `,
  },
  {
    title: "Melihat Status Dokumen Program Akreditasi",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Status Dokumen Program Akreditasi adalah sebagai berikut:
          - Pilih menu Pengelolaan Dokumen pada sidebar kiri halaman.
          - Pilih dan tekan Judul Program yang ingin anda lihat status dokumennya yang terdapat pada tabel Pengelolaan Dokumen.
          - Anda akan masuk ke dalam halaman Detail Pengelolaan Dokumen.
          - Status “Ditolak” yang berarti file/dokumen pada bagian tersebut terdapat kesalahan.
          - Status “Diterima” yang berarti file/dokumen pada bagian tersebut sudah sesuai.
          - Status “Terunggah” yang berarti file/dokumen sudah di upload ulang atau direvisi.
          - Pilih dan tekan “Lihat” yang terdapat di kolom Riwayat untuk melihat riwayat file yang telah diupload pada bagian tersebut.
          - Anda akan masuk ke dalam halaman Detail Riwayat Dokumen.
          - Anda dapat mendownload atau membuka file dengan menekan icon File yang terdapat pada tabel.
      `,
  },
  {
    title: "Melihat Nilai Dokumen dari Setiap Program",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Nilai Dokumen dari Setiap Program adalah sebagai berikut:
          - Pilih menu Penilaian Dokumen pada sidebar kiri halaman.
          - Pilih dan tekan Judul Program yang ingin dipilih yang terdapat pada tabel Penilaian Program.
          - Anda akan masuk ke dalam halaman Detail Penilaian Program.
          - Anda dapat berpindah berdasarkan unsur dengan memilih menu tab seperti diatas.
      `,
  },
  {
    title: "Melihat Detail Informasi Riwayat Pengajuan",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Detail Informasi Riwayat Pengajuan adalah sebagai berikut:
          - Pilih menu Riwayat Pengajuan pada sidebar kiri halaman.
          - Tekan tombol DETAIL untuk melihat informasi lengkap mengenai pengajuan yang dipilih.
          - Anda akan masuk ke dalam halaman Detail Pengajuan yang berisi seluruh informasi mengenai pengajuan tersebut.
      `,
  },
];

export const accordionDataMitra = [
  {
    title: "Registrasi Akun",
    description: `
          Menu Registrasi Akun menjelaskan cara untuk membuat akun yang akan digunakan pada aplikasi ini.
          Langkah-langkah Registrasi pada web aplikasi AKREDITASI adalah sebagai berikut:
          - Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan registrasi
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Anda akan diarahkan ke halaman login SELAIN KEMENTERIAN KEUANGAN
          - Pilih tombol DAFTAR KLC-ID untuk melakukan registrasi akun
          - Anda akan diarahkan ke halaman Daftar Akun
          - Masukan data-data yang dibutuhkan untuk melakukan registrasi akun, lalu tekan tombol DAFTAR.
          - Anda berhasil membuat Akun yang dapat digunakan untuk masuk ke dalam Web Aplikasi Akreditasi.
      `,
  },
  {
    title: "Login dengan Username",
    description: `
          Menu Login dengan username menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun yang didaftar.
          Langkah-langkah login pada Aplikasi SKP dengan menggunakan KLC-ID adalah sebagai berikut:
          - Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan login
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Akan muncul halaman login.
          - Masukkan Username dan Password. Kemudian pilih tombol MASUK.
          - Anda berhasil masuk ke Web Aplikasi AKREDITASI.
      `,
  },
  {
    title: "Login dengan akun Google",
    description: `
          Menu Login dengan username menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun google.
          Langkah-langkah login pada Aplikasi SKP dengan menggunakan KLC-ID adalah sebagai berikut:
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Akan muncul halaman login. Lalu, tekan tombol Masuk dengan Google.
          - Pilih email yang diinginkan.
          - Anda berhasil masuk ke Web Aplikasi AKREDITASI.
      `,
  },
  {
    title: "Masuk ke dalam Dashboard Mitra",
    description: `
          Langkah-langkah yang dilakukan untuk Masuk ke dalam Dashboard Mitra adalah sebagai berikut:
          - Pilih menu profil pengguna pada bagian kanan atas halaman.
          - Pilih tombol Halaman Utama.
          - Anda akan ditampilkan halaman Dashboard Mitra.
      `,
  },
  {
    title: "Mengajukan Permohonan Baru",
    description: `
          Langkah-langkah yang dilakukan untuk Mengajukan Permohonan Baru adalah sebagai berikut:
          - Tekan tombol AJUKAN PERMOHONAN BARU yang terdapat pada Dashboard Mitra.
          - Mengisi form Pengajuan yang dibutuhkan.
          - Tekan tombol SIMPAN untuk menyimpan pengajuan.
          - Akan muncul Pending Page.
          - Anda berhasil Mengajukan Permohonan Baru.
      `,
  },
  {
    title: "Mengisi Biodata Lembaga dan Mengajukan Program",
    description: `
          Langkah-langkah yang dilakukan untuk Mengisi Biodata Lembaga adalah sebagai berikut:
          - Tekan tombol LANJUTKAN AKREDITASI yang terdapat pada Dashboard Mitra (Pengajuan harus sudah berada di Tahap 2).
          - Isi data-data yang dibutuhkan dan judul Program Akreditasi pada Form Permohonan.
          - Tekan tombol SIMPAN untuk menyimpan biodata lembaga.
          - Akan muncul Pending Page.
          - Anda berhasil Mengisi Biodata Lembaga dan Mengajukan Program.
      `,
  },
  {
    title: "Melengkapi Dokumen Akreditasi Program",
    description: `
          Langkah-langkah yang dilakukan untuk Melengkapi Dokumen Akreditasi Program yang diperlukan adalah sebagai berikut:
          - Tekan tombol LANJUTKAN AKREDITASI yang terdapat pada Dashboard Mitra (Pengajuan harus sudah berada di tahap 5).
          - Akan ditampilkan judul-judul program yang diterima, tekan tombol LENGKAPI DOKUMEN pada judul program yang diterima.
          - Pilih file yang ingin diupload dengan cara menekan INPUT FIELD CHOOSE FILE dan pilih file yang ingin dimasukan.
          - Setelah memilih file, tekan tombol UPLOAD untuk mengupload file yang sudah dipilih.
          - Anda dapat berpindah tab berdasarkan unsur dengan menekan Menu Tab yang ada.
          - Setelah seluruh dokumen sudah diupload, tekan tombol CEK KELENGKAPAN DATA untuk menandakan file sudah seluruh terupload.
          - Akan menampilkan icon centang yang menandakan sudah mengupload seluruh file yang diperlukan.
          - Tekan Tombol LANJUTKAN KE TAHAP BERIKUTNYA untuk melanjutkan tahap akreditasi program.
          - Anda berhasil Melengkapi Dokumen Akreditasi Program yang dibutuhkan.
      `,
  },
  {
    title: "Melakukan Revisi Dokumen Akreditasi Program",
    description: `
          Langkah-langkah yang dilakukan untuk Melakukan Revisi Dokumen Akreditasi Program adalah sebagai berikut:
          - Tekan tombol LANJUTKAN AKREDITASI yang terdapat pada Dashboard Mitra (Pengajuan harus sudah berada di tahap 6).
          - Tekan tombol PERIKSA KESESUAIAN DOKUMEN untuk melihat status dokumen pada program yang dipilih.
          - Anda akan masuk ke dalam halaman Detail Periksa Kesesuaian Dokumen Program Akreditasi.
          - Status “Diterima” menandakan bahwa file sudah sesuai dan diterima.
          - Status “Ditolak” menandakan bahwa tidak sesuai berdasarkan Catatan dan ditolak.
          - Status “Terupload” menandakan bahwa anda sudah melakukan atau mengupload ulang file yang salah.
          - Status “Diproses” menandakan bahwa file belum diterima ataupun ditolak.
          - Anda dapat MengUpload Ulang file dengan cara menekan tombol UNGGAH.
          - Akan muncul PopUp untuk mengupload ulang file.
          - Tekan tombol SIMPAN jika file sudah dipilih.
          - Maka Status akan berubah menjadi “Terupload”.
          - Anda berhasil Melakukan Revisi Dokumen akreditasi Program.
      `,
  },
  {
    title: "Melihat Hasil Penilaian Akhir Akreditasi Program",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Hasil Penilaian Akhir akreditasi Program adalah sebagai berikut:
          - Tekan tombol LANJUTKAN AKREDITASI yang terdapat pada Dashboard Mitra (Pengajuan harus sudah berada di tahap 8).
          - Anda akan masuk ke dalam halaman Hasil Penilaian Akhir.
          - Akan ditampilkan Dokumen akhir terkait pengajuan akreditasi serta nilai-nilai, peringkat, dan tanggal mulai dan berakhirnya akreditasi program.
          - Anda berhasil Melihat Hasil Penilaian Akhir Akreditasi Program, tekan tombol KEMBALI KE HALAMAN UTAMA untuk kembali ke Dashboard Mitra.
      `,
  },
  {
    title: "Melanjutkan Pengajuan yang Pernah Diajukan Sebelumnya",
    description: `
          Langkah-langkah yang dilakukan untuk Melanjutkan Pengajuan yang Pernah Diajukan Sebelumnya adalah sebagai berikut:
          - Pilih menu Pengelolaan Akreditasi pada sidebar kiri halaman.
          - Tekan tombol LANJUTKAN pada program yang ingin anda lanjutkan tahap.
          - Anda akan masuk ke dalam halaman untuk melanjutkan tahapan akreditasi sesuai dengan progress tahapan pengajuan anda.
          - Anda berhasil Melanjutkan Pengajuan yang Pernah Diajukan Sebelumnya.
      `,
  },
  {
    title: "Melihat Detail Informasi Pengajuan yang Pernah Diajukan",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Detail Informasi pengajuan yang Pernah Diajukan adalah sebagai berikut:
          - Pilih menu Riwayat Pengajuan pada sidebar kiri halaman.
          - Tekan Tombol DETAIL untuk melihat detail pengajuan yang dipilih.
          - Anda akan masuk ke dalam halaman Detail Pengajuan.
          - Akan ditampilkan seluruh informasi mengenai pengajuan tersebut seperti biodata lembaga, anggota-anggota Assessor dan Penilai Akhir yang ditugaskan pada pengajuan tersebut, serta nilai dari setiap Program yang diajukan.
          - Anda berhasil Melihat Detail informasi Pengajuan yang Pernah Diajukan.
      `,
  },
];

export const accordionDataAssessor = [
  {
    title: "Registrasi Akun",
    description: `
          Menu Registrasi Akun menjelaskan cara untuk membuat akun yang akan digunakan pada aplikasi ini.
          Langkah-langkah Registrasi pada web Aplikasi KLC AKREDITASI adalah sebagai berikut:
          - Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan registrasi
          - Anda akan diarahkan ke halaman pilihan login
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
          - Anda akan diarahkan ke halaman login SELAIN KEMENTERIAN KEUANGAN
          - Pilih tombol DAFTAR KLC-ID untuk melakukan registrasi akun
          - Anda akan diarahkan ke halaman Daftar Akun
          - Masukan data-data yang dibutuhkan untuk melakukan registrasi akun, lalu tekan tombol DAFTAR.
          - Anda berhasil membuat Akun yang dapat digunakan untuk masuk ke dalam Web Aplikasi KLC AKREDITASI.
      `,
  },
  {
    title: "Login dengan Kemenkeu ID",
    description: `
          Menu Login dengan akun Kemenkeu-ID menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun SSO Kemenkeu.
          Langkah-langkah login pada Aplikasi KLC AKREDITASI dengan menggunakan Kemenkeu-ID adalah sebagai berikut:
          - Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan Login.
          - Anda akan diarahkan ke halaman pilihan login.
          - Pilih tombol masuk dengan KEMENTERIAN KEUANGAN.
          - Anda akan diarahkan ke halaman login SSO Kemenkeu.
          - Masukkan Username dan Password. Kemudian pilih tombol Login.
          - Anda berhasil masuk ke Web Aplikasi KLC AKREDITASI sesuai peran masing-masing.
      `,
  },
  {
    title: "Login dengan Username",
    description: `
          Menu Login dengan username menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun yang didaftar.
          Langkah-langkah login pada Aplikasi KLC AKREDITASI dengan menggunakan KLC-ID adalah sebagai berikut:
          - Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN.
          - Akan muncul halaman login.
          - Masukkan Username dan Password. Kemudian pilih tombol MASUK.
          - Anda berhasil masuk ke Web Aplikasi KLC AKREDITASI Admin sesuai peran masing-masing.
      `,
  },
  {
    title: "Logout",
    description: `
          Menu Logout menjelaskan proses menutup sesi di Web Aplikasi KLC AKREDITASI.
          Berikut langkah - langkah melakukan logout:
          - Pilih menu profil pengguna pada bagian kanan atas halaman.
          - Pilih tombol Keluar.
          - Akan muncul pop up sebagai berikut: 
          - Pilih tombol IYA, KELUAR pada konfirmasi untuk menutup sesi.
          - Sistem akan langsung menutup sesi dan meneruskan ke halaman Landing Page.
      `,
  },
  {
    title: "Masuk ke dalam Dashboard Assessor",
    description: `
          Langkah-langkah yang dilakukan untuk masuk ke dalam tampilan dashboard sekretariat adalah sebagai berikut:
          - Pilih menu profil pengguna pada bagian kanan atas halaman.
          - Pilih tombol Halaman Utama.
          - Anda akan ditampilkan halaman Dashboard Assessor. Halaman ini memberikan ringkasan pengajuan dokumen yang perlu Anda tinjau dan setujui.
      `,
  },
  {
    title: "Mengelola Dokumen",
    description: `
          Langkah-langkah yang dilakukan untuk Mengelola Dokumen adalah sebagai berikut:
          - Tekan menu Pengelolaan Dokumen pada sidebar.
          - Untuk meninjau dokumen pada setiap pengajuan, Anda dapat menemukan pengajuan yang diinginkan di dalam tabel. Klik nama program di bawah kolom "Nama Program" untuk membuka tampilan detail dari pengajuan tersebut.
          - Halaman Detail Pengelolaan Dokumen ini menampilkan daftar dokumen yang telah diunggah mitra.
          - Klik pada tab dibawah ini untuk melihat dokumen dalam berbagai unsur program pelatihan.
          - Untuk menerima ataupun menolak dokumen, Anda dapat mengunduh dokumen dengan menekan logo download dokumen pada kolom file.
          - Untuk melihat riwayat revisi dokumen, Anda dapat klik “Lihat” (View) di bawah kolom “Riwayat” (Riwayat) pada tabel untuk melihat detail dan riwayat dokumen yang telah diajukan.
          - Untuk memproses dokumen, pada kolom “Aksi” (Tindakan) Anda memiliki dua pilihan:
              • Terima (Terima): Menyetujui Dokumen.
              • Tolak (Tolak) : Menolak Dokumen.
          - Menerima dokumen:
              • Klik tombol “Terima” (Terima) di sebelah dokumen yang diinginkan.
              • Konfirmasikan tindakan dengan menekan.
          - Menolak dokumen:
              • Klik tombol “Tolak” (Tolak) di sebelah dokumen yang diinginkan.
              • Berikan alasan penolakan jika diperlukan dan konfirmasikan tindakan tersebut.
      `,
  },
  {
    title: "Melanjutkan Tahap",
    description: `
          Untuk dapat memberikan tindakan untuk memproses lebih lanjut setiap penyerahan seperti dibawah ini:
          - Anda dapat melihat dalam kolom Status, jika pada kolom Status terdapat icon centang maka Anda dapat Melanjutkan Tahap.
          - Tekan tombol LANJUTKAN TAHAP untuk melanjutkan tahap terhadap pengajuan tersebut.
          - Anda berhasil Melanjutkan Tahap.
      `,
  },
  {
    title: "Menilai Dokumen Program",
    description: `
          Langkah-langkah yang dilakukan untuk Menilai Dokumen Program adalah sebagai berikut:
          - Pilih menu Penilaian Program pada sidebar kiri halaman.
          - Tekan dan pilih Judul Program yang terdapat pada tabel Penilaian program.
          - Anda dapat berpindah unsur dengan memilih dan menekan tab pada tabel.
          - Tekan Icon panah kebawah untuk melihat informasi detail dokumen.
          - Anda dapat melihat opsi nilai dengan mengarahkan cursor ke icon ‘i’ disamping kolom nilai.
          - Masukan nilai pada kolom input nilai dokumen.
          - Tekan tombol SIMPAN NILAI untuk menyimpan nilai yang sudah dimasukan.
      `,
  },
  {
    title: "Melihat Riwayat Pengajuan",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Riwayat Pengajuan adalah sebagai berikut:
          - Pilih menu Riwayat Pengajuan pada siderbar kiri halaman.
          - Tekan tombol DETAIL untuk melihat Detail Informasi Pengajuan.
          - Anda akan masuk ke dalam halaman Detail Informasi yang berisi mengenai seluruh informasi Pengajuan tersebut seperti biodata lembaga, nama-nama tim Assessor, dan nilai-nilai program yang telah terakreditasi.
          - Anda berhasil Melihat Riwayat Pengajuan.
      `,
  },
];

export const accordionDataSekre = [
  {
    title: "Registrasi Akun",
    description: `
          Menu Registrasi Akun menjelaskan cara untuk membuat akun yang akan digunakan pada aplikasi ini.
          Langkah-langkah Registrasi pada web Aplikasi KLC AKREDITASI adalah sebagai berikut:

          1. Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan registrasi
             
             Anda akan diarahkan ke halaman pilihan login.

          2. Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
             Anda akan diarahkan ke halaman login SELAIN KEMENTERIAN KEUANGAN
             

          3. Pilih tombol DAFTAR KLC-ID untuk melakukan registrasi akun
             
             

          4. Masukan data-data yang dibutuhkan untuk melakukan registrasi akun, lalu tekan tombol DAFTAR.
             Anda berhasil membuat Akun yang dapat digunakan untuk masuk ke dalam Web Aplikasi KLC AKREDITASI.
      `,
  },
  {
    title: "Login dengan Kemenkeu ID",
    description: `
          Menu Login dengan akun Kemenkeu-ID menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun SSO Kemenkeu.
          Langkah-langkah login pada Aplikasi KLC AKREDITASI dengan menggunakan Kemenkeu-ID adalah sebagai berikut:

          1. Pilih tombol MASUK pada bagian kanan atas halaman untuk melakukan Login.
            

          2. Pilih tombol masuk dengan KEMENTERIAN KEUANGAN
             Anda akan diarahkan ke halaman login SSO Kemenkeu
             

          3. Masukkan Username dan Password. Kemudian pilih tombol Login.
             
             Anda berhasil masuk ke Web Aplikasi KLC AKREDITASI sesuai peran masing-masing.
      `,
  },
  {
    title: "Login dengan Username",
    description: `
          Menu Login dengan username menjelaskan cara masuk untuk mulai menjalankan aplikasi ini dengan akun yang didaftar.
          Langkah-langkah login pada Aplikasi KLC AKREDITASI dengan menggunakan KLC-ID adalah sebagai berikut:

          1. Pilih tombol masuk SELAIN KEMENTERIAN KEUANGAN
             
             

          2. Masukkan Username dan Password. Kemudian pilih tombol MASUK.
             `,
  },
  {
    title: "Logout",
    description: `
          Menu Logout menjelaskan proses menutup sesi di Web Aplikasi KLC AKREDITASI.
          Berikut langkah - langkah melakukan logout:

          1. Pilih menu profil pengguna pada bagian kanan atas halaman.
             

          2. Pilih tombol Keluar.
             

          3. Pilih tombol IYA, KELUAR pada konfirmasi untuk menutup sesi.
             Sistem akan langsung menutup sesi dan meneruskan ke halaman Landing Page.
      `,
  },
  {
    title: "Masuk ke dalam Dashboard Sekretariat",
    description: `
          Langkah-langkah yang dilakukan untuk masuk ke dalam tampilan dashboard sekretariat adalah sebagai berikut:

          1. Pilih menu profile pengguna pada bagian kanan atas halaman.
             
          2. Pilih tombol Halaman Utama
             
          3. Anda akan ditampilkan halaman Dashboard Sekretariat
             `,
  },
  {
    title: "Menerima pengajuan lembaga",
    description: `
          Langkah-langkah yang dilakukan untuk Menerima Pengajuan Lembaga adalah sebagai berikut:

          1. Pilih menu Konfirmasi Pengajuan pada bagian sidebar kiri halaman.
            
          2. Pilih Tombol TERIMA pada Tabel Konfirmasi Pengajuan.
            
          3. Akan muncul pop up konfirmasi terima pengajuan sebagai berikut.
            
          4. Masukan nama Lembaga dan upload surat pemberitahuan penerimaan. Kemudian tekan tombol Simpan.
             Anda berhasil Menerima Pengajuan Lembaga.
      `,
  },
  {
    title: "Menolak pengajuan lembaga",
    description: `
          Langkah-langkah yang dilakukan dalam menolak pengajuan sebuah lembaga adalah sebagai berikut:

          1. Pilih menu Konfirmasi Pengajuan pada bagian sidebar kiri halaman.
            
          2. Pilih tombol TOLAK pada Table Konfirmasi Pengajuan
            
          3. Akan muncul pop up konfirmasi tolak pengajuan 
            
          4. Upload surat pemberitahuan penolakan. Kemudian tekan tombol Simpan.
             Anda berhasil Menolak Pengajuan Lembaga.
      `,
  },
  {
    title: "Upload File Konsultasi",
    description: `
          Langkah-langkah yang dilakukan dalam Mengupload file Konsultasi adalah sebagai berikut:

          1. Pilih menu Konfirmasi Pengajuan pada bagian sidebar kiri halaman
            
          2. Pilih Tombol Unggah File Konsultasi pada table Konfirmasi Pengajuan.
            
          3. Akan muncul Pop Up Unggah file surat hasil Konsultasi
            
          4. Upload surat Hasil Konsultasi. Kemudian tekan tombol Simpan.
             akan muncul Pop up Konfirmasi. Kemudian tekan tombol Ya
            `,
  },
  {
    title: "Memproses (Menerima atau Menolak) Program",
    description: `
          Langkah-langkah yang dilakukan untuk Menerima atau Menolak Program adalah sebagai berikut:

          1. Pilih menu Proses Program pada bagian sidebar kiri halaman.
            
          2. Pilih tombol Proses program yang terdapat pada table Proses Program untuk masuk kedalam halaman detail Pengajuan
            
          3. Pada halaman Detail Pengajuan, pilih Tombol “Terima” untuk menerima program, dan “Tolak” untuk menolak program.
            
          4. Akan muncul Pop up Konfirmasi Perubahan status program 
   
          5. Pilih Tombol Simpan untuk konfirmasi perubahan status
             Upload File Surat Pemberitahuan Persetujuan Permohonan Akreditasi Program. Kemudian Pilih Tombol Kirim.

          6. Akan muncul Pop up Konfirmasi Terima Program 

          7. Pilih Tombol Simpan Untuk mengkonfirmasi Terima Program.
             Anda berhasil Menerima/Menolak Program.
      `,
  },
  {
    title: "Menyusun Tim Assessor dan Penilaian Akhir",
    description: `
          Langkah-langkah yang dilakukan untuk Menyusun Tim Assessor dan Tim Penilaian Akhir adalah sebagai berikut:

          1. Pilih menu Susun Tim pada bagian sidebar kiri halaman.

          2. Pilih tombol Susun Tim pada Table Susun Tim untuk masuk ke dalam halaman detail Susun Tim

          3. Masukan data NIP/Nama pegawai yang ingin ditugaskan sebagai Assessor atau Penilai Akhir.

          4. Masukan Minimal 3 Karakter untuk program melakukan pencarian. Kemudian tekan data pegawai yang ingin dipilih.
           
          5. Jika Tim Assessor dan Penilai Akhir sudah dipilih, tekan tombol SIMPAN untuk menyimpan data.
           
          6. Akan muncul Pop up Konfirmasi dengan menampilkan data-data pegawai yang sudah dipilih
           
          7. Pilih Tombol Simpan jika data sudah yakin benar.
             Anda berhasil Menyusun Tim Assessor dan Penilai Akhir.
      `,
  },
  {
    title: "Menghapus dan Menambahkan Tim Assessor atau Penilaian Akhir",
    description: `
          Langkah-langkah yang dilakukan untuk Menambahkan atau Mengurangi Tim Assessor atau Penilaian Akhir adalah sebagai berikut:

          1. Pilih menu Kelola Tim pada bagian sidebar kiri halaman.
           
          2. Pilih tombol SUSUN TIM yang terdapat pada table Kelola Tim untuk masuk ke halaman detail Kelola Tim.
           
          3. Tekan tombol + ANGGOTA untuk menambahkan tim Assessor ataupun tim Penilaian Akhir
           
          4. Akan muncul Pop up 
           
          5. Masukan NIP/NAMA untuk mencari pegawai, masukan minimal 3 karakter untuk mencari.
           
          6. Tekan tombol Simpan untuk menambahkan data pegawai ke dalam Table.
             Tekan tombol SIMPAN PERUBAHAN pada halaman detail kelola tim untuk menyimpan perubahan yang dilakukan.
           
          7. Akan muncul Pop up konfirmasi dengan menampilkan data yang terdapat pada table:
             Tekan tombol Simpan,dan anda Berhasil Menambahkan Tim.

          8. Tekan tombol HAPUS untuk menghapus Pegawai dari Tim Assessor atau Tim Penilaian Akhir.

          9. Akan muncul Pop up konfirmasi untuk penghapusan 
             Tekan Tombol Ya, Hapus jika sudah yakin.
             Anda berhasil Menghapus pegawai dari Tim Assessor atau Tim Penilaian Akhir.
      `,
  },
  {
    title: "Melihat Status Dokumen Setiap Program dan Riwayat File",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Status Dokumen dan Riwayat File dari Setiap Program adalah sebagai berikut:

          1. Pilih menu Pengelolaan Dokumen pada sidebar kiri halaman.
           
          2. Pilih dan tekan judul program yang ingin Anda lihat status dokumennya yang terdapat pada tabel Pengelolaan Dokumen.
           
          3. Anda akan masuk kedalam halaman Detail Pengelolaan Dokumen.
           
          Status:
          - “Ditolak” yang berarti file/dokumen pada bagian tersebut terdapat kesalahan.
          - “Diterima” yang berarti file/dokumen pada bagian tersebut sudah sesuai.
          - “Terunggah” yang berarti file/dokumen sudah di upload ulang atau direvisi.

          4. Pilih dan tekan “Lihat” yang terdapat di kolom Riwayat untuk melihat riwayat file yang telah diupload pada bagian tersebut.
            `,
  },
  {
    title: "Melihat Nilai Dokumen dari Setiap Program",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Nilai Dokumen dari Setiap Program adalah sebagai berikut:

          1. Pilih menu Penilaian Program pada sidebar kiri halaman.
           
          2. Pilih dan tekan Judul Program yang ingin dipilih yang terdapat pada tabel Penilaian Program.
           
          3. Anda akan masuk kedalam halaman Detail Penilaian Program.
           `,
  },
  {
    title: "Memberi Nilai Akhir Akreditasi",
    description: `
          Langkah-langkah yang dilakukan untuk Memberi Nilai Akhir Akreditasi pada suatu Program adalah sebagai berikut:

          1. Pilih menu Penilaian Akhir pada sidebar kiri halaman.
           
          2. Pilih dan tekan tombol UNGGAH NILAI AKHIR yang terdapat pada tabel Penilain Akhir.
           
          3. Pada halaman Detail Penilaian Akhir, anda dapat mengupload file-file yang diperlukan dan memasukan nilai nilai Akreditasi program
             Anda dapat melihat detail Penilaian setiap program dengan menekan tombol Detail Penilaian Dokumen Program.

          4. Tekan tombol SIMPAN jika sudah mengupload file yang diperlukan dan memasukan nilai akreditasi program.
             Akan muncul Pop up konfirmasi untuk menyimpan data.
             Tekan tombol Ya, Lanjutkan jika anda sudah yakin.
             Anda berhasil Memberi Nilai Akhir Program Akreditasi.
      `,
  },
  {
    title: "Melakukan Monitoring dan Evaluasi",
    description: `
          Langkah-langkah yang dilakukan untuk Melakukan Monitoring dan Evaluasi adalah sebagai berikut:

          1. Pilih menu Monitoring dan Evaluasi pada sidebar kiri halaman.
           
          2. Pilih dan tekan tombol AJUKAN EVALUASI yang terdapat dalam tabel Monitoring dan Evaluasi.
           
          3. Akan muncul Pop up konfirmasi 
           
          4. Anda dapat mengupload Surat Permohonan Monitoring dan Evaluasi yang sifatnya opsional.
             Tekan tombol Ya, Lanjutkan untuk mengkonfirmasi permohonan.
             Anda berhasil melakukan Permohonan Monitoring dan Evaluasi.
      `,
  },
  {
    title: "Melihat Riwayat Pengajuan Akreditasi",
    description: `
          Langkah-langkah yang dilakukan untuk Melihat Riwayat Pengajuan Akreditasi adalah sebagai berikut:

          1. Pilih menu Riwayat Pengajuan pada sidebar kiri halaman.
            
          2. Pilih dan tekan tombol Detail yang terdapat pada tabel Riwayat Pengajuan untuk melihat detail informasi mengenai Pengajuan
            
          3. Anda akan masuk ke halaman Detail Informasi Pengajuan 
            `,
  },
];

export const MINIO_URL =
  "https://klcstatic.kemenkeu.go.id/shared/certification/assets";
export const API_URL = `${process.env.NEXT_PUBLIC_API_URL}/akreditasi`;
export const AKREDITASI_UI_URL = process.env.NEXT_PUBLIC_AKREDITASI_UI_URL;
export const ROOT_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_ROOT_URL
    : "http://localhost:3000";
export const API_USR_URL = `${process.env.NEXT_PUBLIC_ROOT_URL}/res/user`;
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
export const RECAPTCHA_SECRET_KEY =
  process.env.NEXT_PUBLIC_RECAPTCHA_SECRET_KEY;
export const KLC_UI_URL = process.env.NEXT_PUBLIC_KLC_UI_URL;
export const API_USR_URL_SERVER =
  process.env.activeEnv === "production"
    ? `http://${process.env.GW_API_SVC_SERVICE_HOST}/res/user`
    : API_USR_URL;
